import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Constant} from '../../global/util/Constant';

@Injectable({
  providedIn: 'root'
})
export class EnterpriseStorageService {
  private url = Constant.ROOT_API_V1.concat('/enterprise/');

  constructor(private http: HttpClient) {
  }

  getBy(enterpriseIdSelected: number) {
    return this.http.get(this.url.concat(String(enterpriseIdSelected)).concat('/storage'));
  }
}
